import React, { ChangeEvent, useState } from "react";
import DropDown from "../../../../components/DropDown";
import InputField from "../../../../components/InputField";
import { getWiFiPatternForQR } from "../../../../helper/functions";
import { EncryptionType } from "../../../../types/types";

interface Props {
  setValue: (value: string) => void;
  prefilledValue?: {
    encryption: EncryptionType;
    password: string;
    name: string;
    hidden: boolean;
  };
  errors?: {
    nameError: string;
    passwordError: string;
  };
}

const GenerateWiFiQr: React.FC<Props> = ({
  setValue,
  prefilledValue,
  errors,
}) => {
  const [encryption, setEncryption] = useState<EncryptionType>(
    prefilledValue ? prefilledValue.encryption : "WPA/WPA2"
  );
  const [password, setPassword] = useState(
    prefilledValue ? prefilledValue.password : ""
  );
  const [name, setName] = useState(prefilledValue ? prefilledValue.name : "");
  const [hidden, setHidden] = useState(
    prefilledValue ? prefilledValue.hidden : false
  );
  return (
    <>
      <InputField
        name="wifi-name"
        value={name}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setName(e.target.value);
          setValue(
            getWiFiPatternForQR(encryption, password, e.target.value, hidden)
          );
        }}
        type="text"
        label="WiFi name (SSID)"
        placeholder="Enter your SSID..."
        error={errors?.nameError}
      />
      <DropDown
        name="encryption"
        options={[
          {
            name: "WPA/WPA2",
            value: "WPA/WPA2",
          },
          {
            name: "WEP",
            value: "WEP",
          },
        ]}
        value={encryption}
        onChange={(e: ChangeEvent<HTMLSelectElement>) => {
          let encryptionStr: EncryptionType =
            e.target.value === "WPA/WPA2" ? "WPA/WPA2" : "WEP";
          setEncryption(encryptionStr);
          setValue(getWiFiPatternForQR(encryptionStr, password, name, hidden));
        }}
        type="text"
        label="Encryption"
        placeholder="Choose encryption..."
      />
      <InputField
        name="wifi-password"
        value={password}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setPassword(e.target.value);
          setValue(
            getWiFiPatternForQR(encryption, e.target.value, name, hidden)
          );
        }}
        type="password"
        label="WiFi password"
        placeholder="Enter your password..."
        error={errors?.passwordError}
      />
      <DropDown
        name="hidden"
        options={[
          {
            name: "YES",
            value: "true",
          },
          {
            name: "NO",
            value: "false",
          },
        ]}
        value={hidden ? "true" : "false"}
        onChange={(e: ChangeEvent<HTMLSelectElement>) => {
          setHidden(e.target.value === "true");
          setValue(
            getWiFiPatternForQR(
              encryption,
              password,
              name,
              e.target.value === "true"
            )
          );
        }}
        type="text"
        label="WiFi is hidden"
        placeholder=""
      />
    </>
  );
};

export default GenerateWiFiQr;
